import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@wds/box';

import getComponentWithTheme from '../../../themeProvider';
import LoginPageContext from './LoginPageContext';
import RegistrationPageContext from './RegistrationPageContext';
import FooterLinks from '../../../sma.common/components/footerLinks';
import MFA from './MFA';

import STRINGS from './constants';
import LockedOut from './components/LockedOut';

const Authentication = (props) => {
	const {
		view = 'login',
		theme = 'default',
		ssoConnection,
		isMarketplace,
		mfaRequired,
		googleUrl,
		siteDetails,
		reCaptchaKey,
		showCaptcha,
		registrationCustomFields,
		nextUrl,
	} = props;
	const [currentView, setCurrentView] = useState(view);

	useEffect(() => {
		const searchParams = new URLSearchParams(window.location.search);
		const viewParam = searchParams.get('view');
		if (['login', 'registration', 'mfa', 'locked-out'].includes(viewParam)) {
			setCurrentView(viewParam);
		}
	}, []);

	useEffect(() => {
		document.title = `${STRINGS.productName} - ${STRINGS?.[currentView]}`;
		let path = '/acc/l/';
		if (currentView === 'register') path = '/acc/r/';
		else if (currentView === 'mfa') path = '/mfa/';
		if (nextUrl) path += `?next=${nextUrl}`;
		window.history.replaceState(null, '', path);
	}, [currentView]);

	return getComponentWithTheme(
		<Box
			justifyContent='space-around'
			alignItems='start'
			style={{
				minWidth: '560px',
				width: '100%',
				height: '100%',
				margin: 'auto',
				overflowX: 'auto',
			}}
		>
			<Box
				className='authentication-container'
				style={{
					height: '100%',
					width: '500px',
					margin: 'auto',
				}}
				py={4}
				display='flex'
				justifyContent='space-around'
				flexDirection='column'
				role='region'
				aria-labelledby='registration-form-title'
				alignItems='center'
			>
				<Box>
					{currentView === 'login' && (
						<LoginPageContext
							siteDetails={siteDetails}
							ssoConnection={ssoConnection}
							isMarketplace={isMarketplace}
							mfaRequired={mfaRequired}
							googleUrl={googleUrl}
							setCurrentView={setCurrentView}
							nextUrl={nextUrl}
						/>
					)}
					{currentView === 'register' && (
						<RegistrationPageContext
							siteDetails={siteDetails}
							reCaptchaKey={reCaptchaKey}
							showCaptcha={showCaptcha}
							registrationCustomFields={registrationCustomFields}
							ssoConnection={ssoConnection}
							isMarketplace={isMarketplace}
							mfaRequired={mfaRequired}
							googleUrl={googleUrl}
							setCurrentView={setCurrentView}
							nextUrl={nextUrl}
						/>
					)}
					{currentView === 'mfa' && (
						<MFA
							mfaRequired={mfaRequired}
							setCurrentView={setCurrentView}
							nextUrl={nextUrl}
						/>
					)}
					{currentView === 'locked-out' && (
						<LockedOut />
					)}
				</Box>
			</Box>
			<FooterLinks siteDetails={siteDetails} />
		</Box>,
		theme,
	);
};

Authentication.propTypes = {
	view: PropTypes.string,
	theme: PropTypes.string,
	ssoConnection: PropTypes.object,
	isMarketplace: PropTypes.bool,
	mfaRequired: PropTypes.bool,
	googleUrl: PropTypes.string,
	siteDetails: PropTypes.object.isRequired,
	reCaptchaKey: PropTypes.string,
	showCaptcha: PropTypes.bool,
	registrationCustomFields: PropTypes.arrayOf(PropTypes.object),
	nextUrl: PropTypes.string,
};

export default Authentication;
